module.exports = __webpack_public_path__ + "static/img/banner.4511e736.png";